export default "\n    <div class=\"dc-section\">\n        <ng-content></ng-content>\n    </div>"